import {
  JUDGE_ADVISOR_ID,
  JUDGE_ID,
  COACH_ID,
  EVENT_ADMIN_ID
} from 'shared/constants/eventRoleTypes';

export default [
  {
    description: 'judgingTeamsSessionFlowChartLabel',
    default: 'https://firstinspires.blob.core.windows.net/fll/challenge/2026-27/fll-challenge-bioglow-judging-session-flowchart.pdf',
    "es-MX": "",
    "tr": "",
    "nl": "",
    "he": "",
    roles: [COACH_ID, JUDGE_ID, JUDGE_ADVISOR_ID, EVENT_ADMIN_ID]
  },
  {
    description: 'BIOGLOW Judging Rubric',
    default: 'https://firstinspires.blob.core.windows.net/fll/challenge/2026-27/fll-challenge-bioglow-rubrics-color.pdf',
    "es-MX": "",
    "tr": "",
    "nl": "",
    "he": "",
    roles: [JUDGE_ID, JUDGE_ADVISOR_ID, COACH_ID, EVENT_ADMIN_ID]
  },
  {
    description: 'BIOGLOW Awards List',
    default: 'https://firstinspires.blob.core.windows.net/fll/challenge/2026-27/fll-challenge-bioglow-awards.pdf',
    "es-MX": "",
    "tr": "",
    "nl": "",
    "he": "",
    roles: [JUDGE_ID, JUDGE_ADVISOR_ID, EVENT_ADMIN_ID]
  },
  {
    description: 'judgingSessionScriptLabel',
    default: "https://firstinspires.blob.core.windows.net/fll/challenge/2026-27/fll-challenge-bioglow-judging-session-script-questions.pdf",
    "es-MX": "",
    "tr": "",
    "nl": "",
    "he": "",
    roles: [JUDGE_ID, JUDGE_ADVISOR_ID, EVENT_ADMIN_ID]
  },
  {
    description: 'awardAllocationLabel',
    default: "https://firstinspires.blob.core.windows.net/fll/challenge/2026-27/fll-challenge-bioglow-awards-and-allocation.pdf",
    "es-MX": "",
    "tr": "",
    "nl": "",
    "he": "",
    roles: [JUDGE_ID, JUDGE_ADVISOR_ID, EVENT_ADMIN_ID]
  },
  {
    description: 'coachMentoNominationSheetLabel',
    default: 'https://firstinspires.blob.core.windows.net/fll/challenge/2026-27/fll-challenge-bioglow-coach-mentor-nomination-print.pdf',
    "es-MX": "",
    "tr": "",
    "nl": "",
    "he": "",
    roles: [COACH_ID, EVENT_ADMIN_ID]
  },
  {
    description: 'BIOGLOW Official Judging Spreadsheet',
    default: 'https://firstinspires.blob.core.windows.net/fll/challenge/2026-27/fll-challenge-bioglow-official-judging-spreadsheet.xlsx',
    "es-MX": "",
    "tr": "",
    "nl": "",
    "he": "",
    roles: [JUDGE_ADVISOR_ID, EVENT_ADMIN_ID]
  },
]
